const localization = {
  label: 'Toggle navigation',
}

export default localization
